import { MenuItem, Select } from '@material-ui/core';
import { IQuestionProps } from 'pages/forms/hooks/useAnswerManager/types';
import React, { useEffect, useState } from 'react';

export const UniqueSelectQuestion = ({ handleChangeAnswer, question, disableInput }: IQuestionProps) => {
  const [inputValue, setInputValue] = useState<Array<number>>([]);

  const handleChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const { value } = event.target;
    const parsedValue = value instanceof Array ? value : [value];

    setInputValue(parsedValue);
    handleChangeAnswer(question.id, { selected: parsedValue });
  };

  useEffect(() => {
    if (question.answer) {
      const savedAnswer = question.answer.selected;
      setInputValue(savedAnswer);
      handleChangeAnswer(question.id, { selected: savedAnswer });
    }
  }, [question]);

  return (
    <Select fullWidth label="Selecione as opções" value={inputValue} onChange={handleChange} disabled={disableInput}>
      {question.options.map(({ id, title }) => (
        <MenuItem value={id} key={id}>
          {title}
        </MenuItem>
      ))}
    </Select>
  );
};
